import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Vuelidate from "vuelidate"
import store from './store'
import { isTokenValid } from '@/auth-tools'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import './registerServiceWorker'
import 'vue-search-select/dist/VueSearchSelect.css'

Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.prototype.$OrdenPagoItem = 'Orden de Pago' //nombre del item cuando se selecciona la opcion de escanear orden de pago, coincide con el servidor

var router = new VueRouter({
  routes: [
    {
      path: '/',
      component: () => import('@/components/login/SipremHome.vue'),
      meta: { 
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/',
      redirect: '/:municipio/login',
      component: () => import('@/components/login/SipremLogin.vue'),
      meta: { 
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/login',
      component: () => import('@/components/login/SipremLogin.vue'),
      meta: { 
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/cobro',
      component: () => import('@/components/cobro/CobroPage.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/:municipio/formas',
      component: () => import('@/components/formas-valoradas/FormasValoradasPage.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/:municipio/reportes',
      component: () => import('@/components/reportes/ReportesPage.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/:municipio/config',
      component: () => import('@/components/configuracion/ConfiguracionPage.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/:municipio/padrones',
      component: () => import('@/components/padrones/padronesPage.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path:'/:municipio/catalogoscat',
      component:()=> import ('@/components/admin/panelCatalogosCatastrales.vue'),
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/:municipio/portalcontribuyente',
      component: () => import('@/components/portalContribuyente/portalContribuyentePage.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/portalagua',
      component: () => import('@/components/portalContribuyente/portalContribuyentePage.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/multipagos',
      component: () => import('@/components/portalContribuyente/PortalMultipagos.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/multipagosv1',
      component: () => import('@/components/portalContribuyente/PortalMultipagosV1.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/multipagosexpress',
      component: () => import('@/components/portalContribuyente/PortalMultipagosExpress.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/payworks',
      component: () => import('@/components/portalContribuyente/PortalPayWorks.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/facturacion',
      component: () => import('@/components/portalContribuyente/PortalFacturacion.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/pagoenlinea',
      component: () => import('@/components/portalContribuyente/PagoEnLinea.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/root',
      component: () => import('@/components/cobro/Root.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/configpinpad',
      component: () => import('@/components/cobro/ConfigPinpad.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/:municipio/parquimetro',
      component: () => import('@/components/portalContribuyente/portalParquimetro.vue'),
      meta: {
        requiresAuth: false
      }
    },
  ],
  mode: "history"
});

router.beforeEach((to, from, next) => {
 // if(to.path == '/'){
  //  next({
   //   path: '/'
    //})
  //}else{
    if(to.matched.some(record => record.meta.requiresAuth)){
      var dateToken = store.state.login.dateToken;
      var token = store.state.login.token;
      if(isTokenValid(token, dateToken)){
        next();
      }else{
        next({
          path: "/"+location.pathname.split("/", 2).toString().replace(",", "")+'/login'
        })
      }
    }else{
      next();
    }
  //}
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
